import { Link } from "react-router-dom";

const DashboardNav = () => {
  const active = window.location.pathname;
  //   console.log(active);
  return (
    <ul className="mainpage nav nav-tabs">
      <li className="nav-item">
        <Link
          className={`nav-link ${active === "/search-result" && "active"}`}
          to="/search-result"
        >
          Search for Tours
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={`nav-link ${active === "/dashboard" && "active"}`}
          to="/dashboard"
        >
          Purchased Tour Library
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={`nav-link ${active === "/dashboard/upload" && "active"}`}
          to="/dashboard/upload"
        >
          Manage on Mobile
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={`nav-link ${active === "/dashboard/seller" && "active"}`}
          to="/dashboard/seller"
        >
          Your Uploaded Tours
        </Link>
      </li>
    </ul>
  );
};

export default DashboardNav;
